
/**
 * @export
 * @enum {string}
 */
export enum UserEventCode {
    CP_ATTR_COPY = 'CP_ATTR_COPY',
    CP_CFG_STATUS_SEL = 'CP_CFG_STATUS_SEL',
    CP_COPY_CONF_VAL = 'CP_COPY_CONF_VAL',
    CP_DOMAINS_ADD = 'CP_DOMAINS_ADD',
    CP_DOM_VERIF_COMPLETE = 'CP_DOM_VERIF_COMPLETE',
    CP_DOM_VERIF_START = 'CP_DOM_VERIF_START',
    CP_DWN_XML = 'CP_DWN_XML',
    CP_HOME_VIEW = 'CP_HOME_VIEW',
    CP_IDP_CARD_SEL = 'CP_IDP_CARD_SEL',
    CP_IDP_CHANGE = 'CP_IDP_CHANGE',
    CP_META_SEL = 'CP_META_SEL',
    CP_META_VALIDATE = 'CP_META_VALIDATE',
    CP_REQ_CO_LOGIN_TOGGLE = 'CP_REQ_CO_LOGIN_TOGGLE',
    CP_SSO_CONFIRM_CHK = 'CP_SSO_CONFIRM_CHK',
    CP_SSO_WIZ_STEP_OPEN = 'CP_SSO_WIZ_STEP_OPEN'
}